import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/99abe0880d4676c15c3ac5e31d85f760.jpg"
          alt="Ocean sunrise"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-12 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-6 block">
            Take The First Step
          </span>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white mb-8 leading-tight">
            Your problems deserve to be so much more complicated than they are.
          </h2>
          <p className="text-xl md:text-2xl text-cream/80 mb-12 max-w-3xl mx-auto leading-relaxed">
            Schedule your complimentary Problem Amplification Consultation. Our over-educated team 
            will over-think your situation, over-complicate every detail, and guarantee a minimum 
            of three bonus problems — absolutely free of charge.
          </p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-wrap items-center justify-center gap-5"
          >
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 bg-gold text-black px-10 py-5 rounded-full text-lg font-bold hover:bg-white transition-all duration-300 whitespace-nowrap"
            >
              Begin Problem Discovery
              <motion.i
                className="ri-arrow-right-line text-2xl"
                whileHover={{ x: 5 }}
              />
            </Link>
            <Link
              to="/financial-success"
              className="group inline-flex items-center gap-3 border-2 border-cream/50 text-cream px-10 py-5 rounded-full text-lg font-bold hover:bg-cream hover:text-black transition-all duration-300 whitespace-nowrap"
            >
              View Our Services
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 flex flex-wrap items-center justify-center gap-8 text-cream/60"
          >
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-gold text-xl"></i>
              <span className="text-sm">No Solutions Provided</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-add-circle-line text-gold text-xl"></i>
              <span className="text-sm">Bonus Problems Guaranteed</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-brain-line text-gold text-xl"></i>
              <span className="text-sm">Maximum Over-Thinking Applied</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-graduation-cap-line text-gold text-xl"></i>
              <span className="text-sm">Dangerously Over-Educated Staff</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;